const getCurrentPath = (pathname = '') =>
  `${pathname.split('/').slice(0, 3).join('/')}/`;

export default getCurrentPath;
